/**
 * studio-shop D8 — the shop's order page (`/shop/orders/:orderId`), also the
 * thank-you page right after paying: each package's progress and tracking, the
 * order's lines and money, where it ships, and where its updates go, with the
 * Telegram offer whose words are the shop plug-in's `signInOffer` option. A
 * money page drawn only by Telify; a custom site styles it through these parts.
 */
import { definePiece } from '../../contract/define';

export const contract = definePiece({
  name: 'shop-order',
  description:
    "The shop's order page, and the thank-you page right after paying: each package's progress and tracking, the lines, the money, where it ships, and where its updates go, with the Telegram offer.",
  drawing: 'standard-only',
  options: {},
  parts: {
    page: { description: 'The whole page.', required: false },
    title: { description: 'Thank you, or the order number.', required: true },
    // site-form-buy-mode D10
    paidLine: { description: "On the thank-you page, under its title: the line a website form's page set for after paying, for an order made with that form's answers.", required: false },
    offer: { description: "The thank-you page's Telegram offer: its heading, the line under it and what signing in gives.", required: false },
    benefit: { description: 'One thing signing in gives.', required: false },
    continueTelegram: { description: 'Continue with Telegram: signs in, and the order comes along.', required: false, role: 'primary-action' },
    notNow: { description: 'Not now: puts the offer away.', required: false },
    updates: { description: 'Where the updates go: by email, Get these as messages, or in Telegram once linked.', required: false },
    openTelegram: { description: "Open in Telegram: the studio's bot, once the updates go there.", required: false, role: 'primary-action' },
    openChat: { description: "Open chat: the studio's bot, while the updates go by email.", required: false, role: 'secondary-action' },
    package: { description: "One package's progress: its steps, its tracking, when it arrives.", required: true },
    tracking: { description: 'The carrier and tracking number, or that it is being made.', required: true },
    trackPackage: { description: "Track your package, on the carrier's site.", required: false, role: 'secondary-action' },
    arrives: { description: "When a package arrives, from its service's estimate.", required: false },
    item: { description: 'One line of the order.', required: true },
    itemName: { description: "A line's product name.", required: true, role: 'title' },
    totals: { description: 'Subtotal, shipping, sales tax, the total and any refunds.', required: true },
    shipTo: { description: 'The name and address the order ships to.', required: true },
    viewOrder: { description: 'View your order, from the thank-you page.', required: false, role: 'secondary-action' },
  },
  actions: {
    signIn: { description: 'Signs in with Telegram; the order comes along.', args: [] },
    notNow: { description: 'Puts the Telegram offer away.', args: [] },
    viewOrder: { description: 'Leaves the thank-you page for the order page.', args: [] },
  },
  events: {},
});

/** What the order page's buttons do. */
export interface ShopOrderActions {
  /** Signs in with Telegram; the order comes along. */
  readonly signIn: () => void;
  /** Puts the Telegram offer away. */
  readonly notNow: () => void;
  /** Leaves the thank-you page for the order page. */
  readonly viewOrder: () => void;
}
